import { animate, state, style, transition, trigger } from '@angular/animations';


export const slideUpDown = [
	trigger( 'slideUpDown', [
		state( '1', style( { height: '*' } ) ),
		state( '0', style( { height: '0px' } ) ),
		transition( '1 <=> 0', animate( 200 ) )
	] )
];


// export const slideLeftRight = [
// 	trigger( 'slideLeftRight', [
// 		state( '1',
// 			style( { 	opacity: '{{ opacity }}', transform: 'translateX({{translateX}})' }),
// 			{params: { translateX: '0', opacity: 1 } } ),
// 		// state( '1',
// 		// 	style( { 	opacity: '{{ opacity }}', transform: 'translateX({{translateX}})' } ),
// 		// 	{params: { transform: 'translateX(0)', opacity: 1 } } ),
// 		// state( '0', style( { transform: 'translateX(-110%)', opacity: 0 } ) ),
// 		state( '0', style( { transform: 'translateX(-110%)', opacity: 1 } ),
// 			{params: { translateX: '-110%', opacity: 1 } } ),
// 		// transition( ':enter', animate( '.2s ease-in-out' ) ),
// 		transition( '* <=> 1', animate( '.2s ease-in-out' ) ),
// 		transition( '* <=> 0', animate( '.2s ease-in-out' ) ),
// 		// transition( ':leave', animate( '.2s ease-in-out' ) )
// 	] )
// ];


export const formErrorSlideUpDown = [
	trigger( 'formErrorSlideUpDown', [
		state(
			':enter',
			style( { opacity: '{{ opacity }}', paddingTop: '0.5rem', paddingBottom: '0.5rem' } ),
			{ params: { height: '*', opacity: '*' } }
		),
		state(
			'1',
			style( { opacity: '{{ opacity }}', paddingTop: '0.5rem', paddingBottom: '0.5rem' } ),
			{ params: { height: '*', opacity: '*' } }
		),
		state( '0', style( { height: '0px', opacity: 0, paddingTop: '0', paddingBottom: '0' } ) ),
		state( ':leave', style( { height: '0px', opacity: 0, paddingTop: '0', paddingBottom: '0' } ) ),
		transition( ':enter', animate( '.2s ease-in-out' ) ),
		transition( '* <=> 1', animate( '.2s ease-in-out' ) ),
		transition( '* <=> 0', animate( '.2s ease-in-out' ) ),
		transition( ':leave', animate( '.2s ease-in-out' ) )
	] )
];


export const formErrorFadeInOut = [
	trigger( 'formErrorFadeInOut', [
		state( ':enter', style( { opacity: 1 } ) ),
		state( ':leave', style( { opacity: 0 } ) ),
		transition( ':enter', animate( '.2s ease-in-out' ) ),
		transition( ':leave', animate( '.2s ease-in-out' ) )
	] )
];
